<template>
  <div class="loading_container" v-if="loading">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only"></span>
    </div>
  </div>

  <div class="main" v-else>
    <!-- Side Navbar -->
    <SideBar />
    <!-- Body-Content -->
    <div class="body-content">
      <!-- Top Navbar -->
      <TopBar />
      <!-- Body -->
      <div class="container-fluid body-container">
        <div class="element">
          <div class="search-box-container">
            <div class="nav">
              <div>
                <h1>Cursos</h1>
                <p>Construa e acelere sua carreira como Assistente Virtual</p>
              </div>
              <div class="search-box">
                <input
                  type="text"
                  id="searchCourseInput"
                  placeholder="Buscar cursos"
                  @input="debounceSearch"
                  :class="{ disabled: searching || loadingMore }"
                  :disabled="searching || loadingMore"
                />
                <button
                  type="submit"
                  @click="searchCourses()"
                  :class="{ disabled: searching || loadingMore }"
                  :disabled="searching || loadingMore"
                >
                  <i class="fa fa-search icons"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="talent-page" v-if="searching">
            <div
              class="loading_container"
              style="height: auto; margin-top: 30px; overflow: hidden"
            >
              <div class="spinner-border text-primary" role="status">
                <span class="sr-only"></span>
              </div>
            </div>
          </div>
          <div class="talent-page" v-else-if="searchError">
            <p class="mt-3 text-center text-danger" style="font-weight: bold">
              Ocorreu um erro ao buscar cursos.<br />
              Por favor, atualize a página e tente novamente.
            </p>
          </div>

          <div class="talent-page" v-else-if="courses && courses.length === 0">
            <p class="mt-3 text-center" style="font-weight: bold" v-if="hasKeywords">
              Nenhum curso encontrado. Tente buscar com outros termos.
            </p>
            <p class="mt-3 text-center" style="font-weight: bold" v-else>
              Nenhum curso disponível ainda. Volte em breve.
            </p>
          </div>
          <div class="talent-page mt-3" v-else>
            <div
              class="mt-3 text-muted"
              style="font-weight: bold"
              v-if="allCoursesGrid.length === 1 && allCoursesGrid[0].length === 0"
            >
              Nenhum curso disponível ainda. Volte mais tarde.
            </div>
            <div class="video_class">
            <div class="alert alert-info mt-3 mb-0">Novos cursos disponíveis!</div>
              <div class="row gy-3 mt-0" v-for="grid in allCoursesGrid">
                <div
                  class="col-md-6 col-lg-4 course"
                  v-for="course in grid"
                  :key="course.id"
                  :id="course.id"
                >
                  <a :href="courseLink(course, this.profile)">
                    <div class="card">
                      <div class="video_img_container">
                        <img
                          class="video_img"
                          :src="getCourseThumbnailURL(course)"
                          alt=""
                        />
                        <span
                          class="tag"
                          v-if="!course.available && course.id === 'form-av'"
                          ><i class="fa fa-lock" /> Exclusivo para membros Virtap
                          Club</span
                        >
                        <span class="tag" v-else-if="!course.available"
                          ><i class="fa fa-lock" /> Saiba mais</span
                        >
                      </div>
                      <div class="card-body">
                        <h4>{{ course.title }}</h4>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
            <div class="page_number"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from "../SideBar.vue";
import TopBar from "../TopBar.vue";
import AssistantManager from "../../../js/services/assistant.js";
import StringUtils from "../../../js/utils/string.js";
import Config from "../../../../resources/config.js";

const RESULT_COUNT = 1000;

import debounce from "lodash.debounce";

const debouncedHandler = debounce((event, func) => {
  func(event.target.value);
}, 500);

export default {
  components: { SideBar, TopBar },

  beforeUnmount() {
    debouncedHandler.cancel();
  },

  created() {
    this.$store.commit("setActiveSection", "CourseListPage");
    this.loadCourses();
  },

  data() {
    return {
      searching: false,
      profile: null,
      courses: [],
      hasKeywords: false,
      searchError: false,
      loadingMore: false,
      hasMore: true,
    };
  },

  computed: {
    loading() {
      return this.$store.state.loading;
    },
    myCoursesGrid() {
      var newArr = [];
      newArr.push(this.courses.slice(0).filter((c) => c.included));
      // for (var i = 0; i < this.courses.length; i += 30) {
      //   newArr.push(this.courses.slice(i, i + 30));
      // }
      return newArr;
    },
    allCoursesGrid() {
      var newArr = [];
      newArr.push(this.courses.slice(0));
      // for (var i = 0; i < this.courses.length; i += 30) {
      //   newArr.push(this.courses.slice(i, i + 30));
      // }
      return newArr;
    },
  },

  methods: {
    async loadCourses() {
      this.$store.commit("setLoading", true);
      try {
        let response = await AssistantManager.searchCourses(
          null,
          true,
          null,
          RESULT_COUNT
        );
        this.courses = response.courses;
        this.profile = response.profile;
        this.$store.commit("setActiveUser", response.profile);
        this.$store.commit("setLoading", false);
        this.hasMore = this.courses.length >= RESULT_COUNT;
      } catch (error) {
        this.handleAPIError(error, "cursos");
      }
    },

    debounceSearch(e) {
      debouncedHandler(e, () => {
        this.searchCourses();
      });
    },

    async searchCourses() {
      let ctx = this;
      ctx.searching = true;
      ctx.searchError = false;
      try {
        let response = await AssistantManager.searchCourses(
          $("#searchCourseInput").val(),
          false,
          null,
          RESULT_COUNT
        );

        this.courses = response.courses;
        this.hasMore = response.courses.length >= RESULT_COUNT;
        this.hasKeywords = !StringUtils.isEmpty($("#searchCourseInput").val());
      } catch (err) {
        console.log(err);
        ctx.searchError = true;
      } finally {
        ctx.searching = false;
        ctx.$nextTick(() => {
          $("#searchCourseInput").focus();
          ctx.applyTruncation();
        });
      }
    },

    async fetchMore() {
      let ctx = this;
      ctx.loadingMore = true;
      ctx.searchError = false;
      let lastCourse = null;
      if (this.courses && this.courses.length > 0) {
        lastCourse = this.courses[this.courses.length - 1];
      }
      try {
        let response = await AssistantManager.searchCourses(
          $("#searchCourseInput").val(),
          false,
          lastCourse,
          RESULT_COUNT
        );

        this.courses = this.courses.concat(response.courses);
        if (response.courses.length < RESULT_COUNT) {
          this.hasMore = false;
        }

        ctx.$nextTick(() => {
          ctx.applyTruncation(() => {
            if (response.courses.length > 0) {
              let card = $(".talent-page")
                .find("#" + response.courses[0].id)
                .get(0);
              let navBar = $(".body-container .element .nav").get(0);
              let scrollDiv = card.offsetTop - navBar.offsetHeight - 116;
              window.scrollTo({ top: scrollDiv, behavior: "smooth" });
            }
          });
        });
      } catch (err) {
        console.log(err);
      } finally {
        ctx.loadingMore = false;
      }
    },

    courseLink(course, profile) {
      return "/curso/" + course.id;

      // if (course.available) {
      //   return "/curso/" + course.id;
      // } else if (course.plan === "VirtapClub" && profile.plan !== "VirtapClub") {
      //   return Config.virtapClubPage;
      // } else if (course.id === "form-ap") {
      //   return Config.formAPPage;
      // } else {
      //   //        throw new Error("Invalid course ID:" + course.id);
      // }
    },
  },
};
</script>
